import { connect } from "react-redux"
import Search from "./Search"

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Search)
